import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=75ed24e5&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"
import style0 from "./NewsView.vue?vue&type=style&index=0&id=75ed24e5&prod&lang=scss&scoped=true"
import style1 from "./NewsView.vue?vue&type=style&index=1&id=75ed24e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed24e5",
  null
  
)

export default component.exports